import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { startNewTrace } from "./correlation";

/**
 * Mounts inside the BrowserRouter and starts a fresh W3C trace on every
 * route navigation. All apiFetch() calls within the new route share the same
 * trace-id (each call mints its own span-id), so the operator can pivot from
 * "alert fired on /portfolio/generate" → backend Cloud Logging filtered to
 * a single trace-id → the entire chain (HTTP request → Pub/Sub messages →
 * worker spans) for that one user action.
 *
 * Action boundary = route change. In-page button clicks share the route's
 * trace-id, which is acceptable for the alert-pivot use case (the operator
 * narrows by timestamp within the trace). Per-click trace boundaries would
 * require touching every click handler — Tier 2 / OTel browser SDK
 * territory.
 */
export function useTraceOnRouteChange(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    startNewTrace();
  }, [pathname]);
}
